/* eslint-disable no-unused-vars */
/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
export const mfgNameFieldLabel = 'Manufacturer Name';
export const mfgIdFieldLabel = 'ID';
export const contractsGridLabel = 'Contracts';
export const nameLabel = 'Name';
export const corporationNameLabel = 'Corporation Name';
export const addressLine1Label = 'Address Line 1';
export const addressLine2Label = 'Address Line 2';
export const addressLine3Label = 'Address Line 3';
export const cityLabel = 'City';
export const stateLabel = 'State';
export const zipLabel = 'Zip';
export const zip4Label = 'Zip+4';
export const phoneNumberLabel = 'Phone Number';
export const extensionLabel = 'Extension';
export const faxNumberLabel = 'Fax Number';
export const emailLabel = 'Email Address';
export const errorTypeNoData = 'noData';
export const errorTypeValidate = 'validate';
export const navigate = '/labelerDifferences';
export const useCmsContact = 'Use This Contact';
export const useDramsContact = 'Use Manufacturer Invoice Contact';
export const deleteThisContact = 'Delete Manufacturer Invoice Contact';
export const SUCCESS_MAINTAIN = 'System successfully saved the information!';
